import * as yup from 'yup';

export const emailValidationSchema = yup
  .string()
  .email('validEmailAddress')
  .required('requiredField');

export const numberInIntervalSchema = (min, max) =>
  yup.number().min(min).max(max);
